import { API_CONFIG } from '../../shared/api/config';
import composeRequest, { getPaginatedResponse } from '../../shared/api/core';
import { ProcessUnknownIdentifierData, UnknownIdentifier } from '../models';
// import {StatusFilter} from '../screens/UnknownIdentifierHistory/UnknownIdentifierHistory.web'
const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    productsNoBarcodesUrl: BASE_URL + 'korona/reports/products/no-barcode/',
    productsDuplicateNameUrl: BASE_URL + 'korona/reports/products/duplicate-name/',
    unMappedBusinessProductsUrl: BASE_URL + 'korona/unmapped-products/',
    masterSupplierProductsWithoutCaseCodeUrl:
        BASE_URL + 'korona/master/supplier-products-without-case-code/',
    masterSupplierProductsWithoutCaseQtyUrl:
        BASE_URL + 'korona/master/supplier-products-without-case-qty/',
    masterSupplierProductsWithoutIdentifiersUrl:
        BASE_URL + 'korona/master/supplier-products-without-identifiers/',
    masterSupplierProductsWithoutUnitMeasureUrl:
        BASE_URL + 'korona/master/supplier-products-without-uom/',
    masterProductsDuplicatesUrl: BASE_URL + 'korona/master/product-duplicates/',
    masterIdentifierDuplicatesURL: BASE_URL + 'korona/master/product-duplicates-identifier/',//identifier duplicates url
    masterProductsWithoutIdentifiersUrl: BASE_URL + 'korona/master/products-without-identifiers/',
    masterProductsWithoutQtyValuesUrl: BASE_URL + 'korona/master/products-without-qty-values/',
    masterProductsWithoutUnitMeasureUrl: BASE_URL + 'korona/master/products-without-uom/',
    masterProductsNameUnitMismatchUrl: BASE_URL + 'korona/master/name-unit-mismatch/',
    masterProductsBrandMismatchUrl: BASE_URL + 'korona/master/product-brand-mismatch/',
    masterSupplierProductIdentifiersUrl: BASE_URL + 'korona/master/supplier-product-identifiers/',
    rmsHQItemsReport: BASE_URL + 'korona/reports/rms/items-mismatch',
    rmsCostPriceReport: BASE_URL + 'korona/reports/rms/cost-price',
    unknownIdentifierUrl: BASE_URL + 'korona/reports/unknown-identifier-history/',
    // unknownIdentifierReportUrl: BASE_URL + 'korona/reports/unknown-identifier-history/summary/',
    processUnknownIdentifierUrl: BASE_URL + 'korona/reports/unknown-identifier/toggle-processed',
    unknownIdentifierProbableProductsUrl:
        BASE_URL + 'korona/reports/unknown-identifier/probable-products',
    unknownIdentifierSearchActivityUrl:
        BASE_URL + 'korona/reports/unknown-identifier/search-activity',
    unknownIdentifierReceiptDetailUrl:
        BASE_URL + 'korona/reports/unknown-identifier/receipt-detail',
    expectedStockByWeekBySupplierUrl:
        BASE_URL + 'korona/reports/expected-stock-by-week-by-supplier/',
    expectedStockByWeekByCgroupUrl:
        BASE_URL + 'korona/reports/expected-stock-by-week-by-commodity-group/',
    productsWithStorePriceUrl: BASE_URL + 'korona/reports/products/store-price/',
    // productPriceDetailByLastSold : BASE_URL + 'korona/reports/price-detail/'
    productPriceDetailByLastSold: BASE_URL + 'korona/reports/products/price-last-sold/',
    produceCodesUrl: BASE_URL + 'korona/reports/produce-codes/',
    supplierProductListUrl: BASE_URL + 'korona/reports/supplier-product-list/',
    retailterCodeNotLinkedMasterProductIdentifierUrl: BASE_URL + 'korona/reports/retailer-code-not-in-linked-master-product-identifier/',
    supplierReorderCodeMismatchUrl: BASE_URL + 'korona/reports/supplier-reorder-code-mismatch/',
    retailerBusinessIdUrl: BASE_URL + 'korona/master/retailer/business/',
    supplierEntryMultiplesInSameItemUrl: BASE_URL + 'korona/reports/supplier-entry-multiples-in-same-item/',
    supplierProductsNotLinkedToMaster: BASE_URL + 'korona/reports/supplier-items-not-linked-to-master/',
    retailersSupplierItemsNotLinkedToMasterItem: BASE_URL + 'korona/reports/retailers-supplier-items-not-linked-to-master-item/',
    updateProductRetailerUrl: BASE_URL + 'korona/update-product-retailers-supplier-record',
    updateSupplierProductUrl: BASE_URL + 'korona/update-supplier-product-record',
    addMasterProductIdentifier: BASE_URL + 'korona/reports/retailer-code-not-in-linked-master-product-identifier/add_master_product_identifier',
    masterBusinessProductNameMismatch: BASE_URL + 'korona/reports/master-business-product-name-mismatch/',
    addExcludeBusinessCodeLinkedMpi: BASE_URL + 'korona/reports/retailer-code-not-in-linked-master-product-identifier/add_exclude_bussiness_code_linked_mpi',
    getMasterProductsOrphansUrl: BASE_URL + 'korona/reports/master-product-orphans/',
    productsWithPriceMissingOrZeroUrl: BASE_URL + 'korona/reports/price-missing-or-zero/',
    salesReportByBusiness: BASE_URL + 'korona/reports/sales-data-summary/',
    masterItemLinkedRetailerMultipleItemsUrl: BASE_URL + 'korona/reports/master-item-linked-retailer-multiple-items/',
    productsWithMarginLessThanZeroUrl: BASE_URL + 'korona/reports/products-with-margin-less-than-zero/',
    mpIdentifiersCaseQuantityMismatchSuppProductCaseQuantityUrl: BASE_URL + 'korona/reports/mpi-cq-mismatch-supplier-cq/',
    suppliersLinkedToRetailersUrl: BASE_URL + 'korona/reports/suppliers-link-retailer/',
    productMarginsUrl: BASE_URL + 'korona/reports/product-margins/',
    supplierRocInMultipleItemsUrl: BASE_URL + 'korona/reports/supp-roc-multiple-items/',
    retailerCodesWithinGroupNotInMasterIdentifierUrl: BASE_URL + 'korona/reports/retailer-codes-within-group-not-in-master-identifier/',
    companiesBrandsInRtlCodeWithinGroupReportUrl: BASE_URL + 'korona/reports/get-all-companies-brands-retailer-codes-within-group-not-in-master-identifier',
    addExcludeBusinessCodeRtlWithinGrpMpiUrl: BASE_URL + 'korona/reports/retailer-codes-within-group-not-in-master-identifier/exclude-bussiness-code',
    tagsToRemoveCodeUrl: BASE_URL + 'korona/reports/tags-to-remove-code/',
    tagsToRemovePriceUrl: BASE_URL + 'korona/reports/tags-to-remove-price/',
    masterItemLinkedToDeletedItemsUrl: BASE_URL + 'korona/reports/master-item-linked-to-deleted-item/',
    rocBySuppCompanyUrl: BASE_URL + 'korona/reports/roc-by-supp-company/',
    getLiquorLiterTaxMismatchUrl: BASE_URL + 'korona/reports/liquor-liter-mismatch/',
    getApnaBazaarHomeneedsDataMismatchUrl: BASE_URL + 'korona/reports/apna-bazaar-homeneeds-data-mismatch/',
    getCGParentProductUrl: BASE_URL + 'korona/reports/commodity-group-parent-products/',
    getApnaBazaarHomeneedsCostToPriceMismatchUrl: BASE_URL + 'korona/reports/apna-bazaar-homeneeds-cost-to-price-mismatch/',
    containerSubItemsLinksUrl: BASE_URL + 'korona/reports/container-subitems-links/',
    getProductsMostRecentSRUrl: BASE_URL + 'korona/reports/prods-most-recent-sr/',
    getHNSuppUpdateSummaryUrl: BASE_URL + 'korona/reports/hm-suppl-update-summary/',
    cgByEBTSectorDiscSummaryUrl: BASE_URL + 'korona/reports/cg-ebt-sector-disc-summary/',
    businessYearlyComparisonUrl: BASE_URL + 'korona/reports/business-yearly-comparison',
    salesByRootCommodityGroupUrl: BASE_URL + 'korona/reports/sales-by-root-commodity-group',
    downloadProductReportUrl: BASE_URL + 'korona/reports/download-product-report/',
    getRetailerItemMasterItemCodeLinkMismatchUrl: BASE_URL + 'korona/reports/retailer-item-master-item-code-link-mismatch/',
    employeeWorkTimeReportUrl: BASE_URL + 'korona/reports/employee-work-time/',
    posSalesByPaymentMethodReportUrl: BASE_URL + 'korona/reports/pos-sales/',
    salesByDateCommodityGroupReportUrl: BASE_URL + 'korona/reports/sales-by-date-commodity-group/',
    leafCommodityGroupsUrl: BASE_URL + 'korona/commodity-groups/leaf_commodity_groups/', // New API URL
    inventoryReportUrl: BASE_URL + 'korona/reports/inventory-order-report/',
    inventoryReportSnapshotsUrl: BASE_URL + 'korona/reports/inventory-order-report/snapshots/',
    inventorySnapshotTasksUrl: BASE_URL + 'korona/reports/inventory-order-report/snapshot-tasks/',
};

export const getLeafCommodityGroups = (business_id: number | string, searchTerm: string | null = null) => {
    let URL = API_URLS.leafCommodityGroupsUrl + `?business_id=${business_id}`;
    if (searchTerm) {
        URL = `${URL}?search=${encodeURIComponent(searchTerm)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getSalesByDateCommodityGroupReport = (
    business_id: number | string,
    location_ids: string,
    start_date: string,
    end_date: string,
    commodity_group_number: string | null, // New parameter
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean,
    showOnlyRowsWithSales?: boolean // New parameter
) => {
    let URL = API_URLS.salesByDateCommodityGroupReportUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_id=${business_id}&location_ids=${location_ids}&start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`;
    } else {
        URL = `${URL}?business_id=${business_id}&location_ids=${location_ids}&start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`;
    }
    if (commodity_group_number) { // Add commodity_group_number to URL
        URL = `${URL}&commodity_group_number=${encodeURIComponent(commodity_group_number)}`;
    }
    if (page) {
        URL = `${URL}&page=${page}`;
    }
    if (pageSize) {
        URL = `${URL}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${encodeURIComponent(searchTerm)}`;
    }
    if (orderBy) {
        URL = `${URL}&order_by=${orderBy}`;
    }
    if (showOnlyRowsWithSales) { // Add show_only_rows_with_sales to URL
        URL = `${URL}&show_only_rows_with_sales=true`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getPosSalesByPaymentMethodReport = (
    business_id: number | string,
    location_ids: string,
    start_date: string,
    end_date: string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.posSalesByPaymentMethodReportUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_id=${business_id}&location_ids=${location_ids}&start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`;
    } else {
        URL = `${URL}?business_id=${business_id}&location_ids=${location_ids}&start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${encodeURIComponent(searchTerm)}`;
    }
    if (orderBy) {
        URL = `${URL}&order_by=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getEmployeeWorkTimeReport = (
    business_id: number | string,
    location_ids: number | string,
    start_date: string,
    end_date: string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.employeeWorkTimeReportUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}&location_ids=${location_ids}&start_date=${start_date}&end_date=${end_date}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&location_ids=${location_ids}&start_date=${start_date}&end_date=${end_date}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&order_by=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const addMasterProductIdentifier = (data: any) => {
    const URL = API_URLS.addMasterProductIdentifier;
    return composeRequest(URL, 'POST', JSON.stringify(data));
};

export const addExcludeBusinessCodeLinkedMpi = (data: any) => {
    const URL = API_URLS.addExcludeBusinessCodeLinkedMpi;
    return composeRequest(URL, 'POST', JSON.stringify(data));
};


export const getUnknownIdentifiersReport = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: any,
    shouldExport?: boolean,
    location_ids?: string
) => {
    let URL;
    if (shouldExport) {
        URL = `${API_URLS.unknownIdentifierUrl}export/?business_ids=${business_id}`;
    } else {
        URL = `${API_URLS.unknownIdentifierUrl
            }?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    if (location_ids) {
        URL = `${URL}&location_ids=${location_ids}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters && filters.length > 0) {
        filters.forEach((f: { filterString: string | null }) => {
            if (f.filterString) {
                URL = URL + f.filterString;
            }
        });
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getExpectedStockByWeek = (
    reportType: 'by_supplier' | 'by_cgroup',
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.expectedStockByWeekByCgroupUrl;
    if (reportType === 'by_supplier') {
        URL = API_URLS.expectedStockByWeekBySupplierUrl;
    }
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getproductPriceDetailByLastSold = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.productPriceDetailByLastSold;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getProductsWithStorePrice = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.productsWithStorePriceUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getSupplierEntryMultiplesInSameItem = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.supplierEntryMultiplesInSameItemUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getSupplierProductNotLinkedToMaster = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.supplierProductsNotLinkedToMaster;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getProduceCodes = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.produceCodesUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getRetailterCodeNotLinkedMasterProductIdentifier = (
    retailer_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.retailterCodeNotLinkedMasterProductIdentifierUrl;
    if (shouldExport) {
        URL = `${URL}export/?retl_id=${retailer_id}`;
    } else {
        URL = `${URL}?retl_id=${retailer_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getSupplierProductList = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.supplierProductListUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const processUnknownIdentifier = (
    data: ProcessUnknownIdentifierData | UnknownIdentifier
) => {
    let URL = `${API_URLS.processUnknownIdentifierUrl}`;
    return composeRequest(URL, 'PUT', JSON.stringify(data));
};

export const getUnknownIdentifierProbableProducts = (
    business_id: number | string,
    unknown_code: string,
) => {
    const URL = `${API_URLS.unknownIdentifierProbableProductsUrl}?business_id=${business_id}&unknown_code=${encodeURIComponent(unknown_code)}`;
    return composeRequest(URL, 'GET', null);
};

export const getUnknownIdentifierSearchActivity = (
    business_id: number | string,
    unknown_code: string,
) => {
    const URL = `${API_URLS.unknownIdentifierSearchActivityUrl}?business_id=${business_id}&unknown_code=${encodeURIComponent(unknown_code)}`;
    return composeRequest(URL, 'GET', null);
};

export const getUnknownIdentifierReceiptDetail = (
    business_id: number | string,
    history_id: number,
    unknown_code?: string,
    product_uuid?: string,
) => {
    let URL = `${API_URLS.unknownIdentifierReceiptDetailUrl}?business_id=${business_id}&history_id=${history_id}`;
    if (unknown_code) {
        URL += `&unknown_code=${encodeURIComponent(unknown_code)}`;
    }
    if (product_uuid) {
        URL += `&product_uuid=${encodeURIComponent(product_uuid)}`;
    }
    return composeRequest(URL, 'GET', null);
};

// To check if these functions are called
export const getMasterProductDuplicates = (
    page: number,
    pageSize: number,
    searchTerm: string | null
) => {
    return getPaginatedResponse(API_URLS.masterProductsDuplicatesUrl, page, pageSize, searchTerm);
};
export const getMasterProductsUnitMismatch = (
    page: number,
    pageSize: number,
    searchTerm: string | null
) => {
    return getPaginatedResponse(
        API_URLS.masterProductsNameUnitMismatchUrl,
        page,
        pageSize,
        searchTerm
    );
};
export const getMPWithoutIdentifiers = (
    page: number,
    pageSize: number,
    searchTerm: string | null
) => {
    return getPaginatedResponse(
        API_URLS.masterProductsWithoutIdentifiersUrl,
        page,
        pageSize,
        searchTerm
    );
};
export const getMPWithoutQtyValues = (
    page: number,
    pageSize: number,
    searchTerm: string | null
) => {
    return getPaginatedResponse(
        API_URLS.masterProductsWithoutQtyValuesUrl,
        page,
        pageSize,
        searchTerm
    );
};

export const getMasterIdentifierDuplicates = (
    page: number,
    pageSize: number,
    searchTerm: string | null
) => {
    return getPaginatedResponse(API_URLS.masterIdentifierDuplicatesURL, page, pageSize, searchTerm);
};

export const getRetailBusinessIds = () => {
    let URL = API_URLS.retailerBusinessIdUrl;
    return composeRequest(URL, 'GET', null)
}


export const updateProductRetailersSupplier = (payload) => {
    const URL = `${API_URLS.updateProductRetailerUrl}`;
    return composeRequest(URL, 'POST', JSON.stringify(payload))

};

export const updateSuppliersProduct = (payload) => {
    const URL = `${API_URLS.updateSupplierProductUrl}`;
    return composeRequest(URL, 'POST', JSON.stringify(payload))

};







export const getMasterBusinessProductNameMismatch = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.masterBusinessProductNameMismatch;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getMasterProductOrphans = (
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy: string | number,
    shouldExport?: boolean

) => {
    let URL = API_URLS.getMasterProductsOrphansUrl + `?page=${page}&page_size=${pageSize}`;
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}


export const getProductsWithPriceMissingOrZero = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.productsWithPriceMissingOrZeroUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getSalesReportByBusiness = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean,
    prevData?: any | null,
) => {
    let URL = API_URLS.salesReportByBusiness;
    if (shouldExport) {
        URL = `${URL}export/?business_id=${business_id}`;
    } else {
        URL = `${URL}summary/?business_id=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&ordering=${orderBy}`;
    }
    if (prevData) {

        URL += "&" + new URLSearchParams(prevData).toString();
    }
    return composeRequest(URL, 'GET', null);
};

export const getMasterItemLinkedRetailerMultipleItems = (
    page: number,
    pageSize: number,
    searchTerm: string | null,
    orderBy: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.masterItemLinkedRetailerMultipleItemsUrl
        + '?page=' + page + '&page_size=' + pageSize;
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = API_URLS.productsDuplicateNameUrl
            + '?search=' + searchTerm + '&page=' + page + '&page_size=' + pageSize;
    }
    if (shouldExport) {
        URL = `${API_URLS.masterItemLinkedRetailerMultipleItemsUrl}export/`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};



export const getProductsWithMarginLessThanZero = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.productsWithMarginLessThanZeroUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        let orderByUpdated = orderBy === 'purchase_price_converted' ? 'purchase_price' : orderBy === '-purchase_price_converted' ? '-purchase_price' : orderBy

        URL = `${URL}&orderBy=${orderByUpdated}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getMpIdentifiersCaseQuantityMismatchSuppProductCaseQuantity = (
    page: number,
    pageSize: number,
    searchTerm: string | null,
    orderBy: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.mpIdentifiersCaseQuantityMismatchSuppProductCaseQuantityUrl
        + '?page=' + page + '&page_size=' + pageSize;
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = API_URLS.mpIdentifiersCaseQuantityMismatchSuppProductCaseQuantityUrl
            + '?search=' + searchTerm + '&page=' + page + '&page_size=' + pageSize;
    }
    if (shouldExport) {
        URL = `${API_URLS.mpIdentifiersCaseQuantityMismatchSuppProductCaseQuantityUrl}export/`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getSuppliersLinkedToRetailers = (
    page: number,
    pageSize: number,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy: string | number,
    filters?: string,
    shouldExport?: boolean
) => {
    let URL = API_URLS.suppliersLinkedToRetailersUrl
        + '?page=' + page + '&page_size=' + pageSize + '&tot_recs_found=' + totalRecs;
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = API_URLS.suppliersLinkedToRetailersUrl
            + '?search=' + searchTerm + '&page=' + page + '&page_size=' + pageSize;
    }
    if (shouldExport) {
        URL = `${API_URLS.suppliersLinkedToRetailersUrl}export/`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    if (filters) {
        URL += filters;
    }
    return composeRequest(URL, 'GET', null);
};


export const getProductMargins = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.productMarginsUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        // let orderByUpdated = orderBy === 'purchase_price_converted' ? 'purchase_price' : orderBy === '-purchase_price_converted' ? '-purchase_price': orderBy

        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}



export const getSupplierROCInMultipleItems = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.supplierRocInMultipleItemsUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getCompaniesBrandsInRtlCodeWithinGroupReport = () => {
    const URL = API_URLS.companiesBrandsInRtlCodeWithinGroupReportUrl;
    return composeRequest(URL, 'GET', null);
};

export const getRetailerCodesWithinGroupNotInMasterIdentifier = (
    page: number,
    pageSize: number,
    searchTerm: string,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.retailerCodesWithinGroupNotInMasterIdentifierUrl + '?page=' + page + '&page_size=' + pageSize + '&tot_recs_found=' + totalRecs;
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = API_URLS.retailerCodesWithinGroupNotInMasterIdentifierUrl + '?search=' + searchTerm + '&page=' + page + '&page_size=' + pageSize;
    }
    if (shouldExport) {
        URL = `${API_URLS.retailerCodesWithinGroupNotInMasterIdentifierUrl}export/?search=''`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const addExcludeBusinessCodeRtlWithinGrpMpi = (data: any) => {
    const URL = API_URLS.addExcludeBusinessCodeRtlWithinGrpMpiUrl;
    return composeRequest(URL, 'POST', JSON.stringify(data));
};


export const getTagsToRemoveCode = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.tagsToRemoveCodeUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}

export const getTagsToRemovePrice = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.tagsToRemovePriceUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}


export const getMasterItemLinkedToDeletedItems = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.masterItemLinkedToDeletedItemsUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}


export const getRocBySupplier = (
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    filters: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.rocBySuppCompanyUrl;
    if (shouldExport) {
        URL = `${URL}export/`;
    } else {
        URL = `${URL}?page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}



export const getLiquorLiterTaxMismatch = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getLiquorLiterTaxMismatchUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getApnaBazaarHomeneedsDataMismatch = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getApnaBazaarHomeneedsDataMismatchUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getCommodityGroupParentProducts = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getCGParentProductUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getApnaBazaarHomeneedsCostToPriceMismatch = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getApnaBazaarHomeneedsCostToPriceMismatchUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getContainerSubItemsLinksUrl = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.containerSubItemsLinksUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getRetailerItemMasterItemCodeLinkMismatch = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getRetailerItemMasterItemCodeLinkMismatchUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getProductsMostRecentSR = (
    business_id: number | string,
    korona_supp_id: string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getProductsMostRecentSRUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_id=${business_id}&korona_supp_id=${korona_supp_id}`;
    } else {
        URL = `${URL}?business_id=${business_id}&korona_supp_id=${korona_supp_id}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};


export const getHNSuppUpdateSummary = (
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    shouldExport?: boolean
) => {
    let URL = API_URLS.getHNSuppUpdateSummaryUrl;
    if (shouldExport) {
        URL = `${URL}export/`;
    } else {
        URL = `${URL}?page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
}

export const getCgByEBTSectorDiscSummary = (
    business_id: number | string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    totalRecs: boolean,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean
) => {
    let URL = API_URLS.cgByEBTSectorDiscSummaryUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_ids=${business_id}`;
    } else {
        URL = `${URL}?business_ids=${business_id}&page=${page}&page_size=${pageSize}&tot_recs_found=${totalRecs}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${searchTerm}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getBusinessYearlyComparison = (
    this_period_start_datetime: string,
    this_period_end_datetime: string,
    prev_period_start_datetime: string,
    prev_period_end_datetime: string,
    businessIds: string,
    export_csv: boolean = false
) => {
    let URL = `${API_URLS.businessYearlyComparisonUrl}?this_period_start_datetime=${this_period_start_datetime}&this_period_end_datetime=${this_period_end_datetime}&prev_period_start_datetime=${prev_period_start_datetime}&prev_period_end_datetime=${prev_period_end_datetime}&business_ids=${businessIds}`;
    if (export_csv) {
        URL += `&export_csv=true`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getSalesByRootCommodityGroup = (
    current_start_datetime: string | undefined,
    current_end_datetime: string | undefined,
    previous_start_datetime: string | undefined,
    previous_end_datetime: string | undefined,
    businessIds: string,
    export_csv: boolean = false
) => {
    let URL = `${API_URLS.salesByRootCommodityGroupUrl}?business_ids=${businessIds}`;
    if (current_start_datetime) {
        URL += `&this_period_start_datetime=${current_start_datetime}`;
    }
    if (current_end_datetime) {
        URL += `&this_period_end_datetime=${current_end_datetime}`;
    }
    if (previous_start_datetime) {
        URL += `&prev_period_start_datetime=${previous_start_datetime}`;
    }
    if (previous_end_datetime) {
        URL += `&prev_period_end_datetime=${previous_end_datetime}`;
    }
    if (export_csv) {
        URL += `&export_csv=true`;
    }
    return composeRequest(URL, 'GET', null);
};

export const downloadProductReportApi = (businessId: number | string) => {
    const URL = `${API_URLS.downloadProductReportUrl}${businessId}/`;
    // Assuming composeRequest returns a Promise<Response> (standard Fetch API Response)
    // The component will handle .blob() and headers.
    return composeRequest(URL, 'GET', null);
};

// Inventory Report API functions
export const getInventoryReport = (
    business_id: number | string,
    location_ids: string,
    page: number | null,
    pageSize: number | null,
    searchTerm: string | null,
    orderBy?: string | number,
    filters?: string | null,
    shouldExport?: boolean,
    snapshotId?: number | string | null,
    accountForReceived?: boolean
) => {
    let URL = API_URLS.inventoryReportUrl;
    if (shouldExport) {
        URL = `${URL}export/?business_id=${business_id}&location_ids=${location_ids}`;
        if (snapshotId != null && snapshotId !== '') {
            URL += `&snapshot_id=${snapshotId}`;
        }
    } else {
        URL = `${URL}?business_id=${business_id}&location_ids=${location_ids}&page=${page}&page_size=${pageSize}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${encodeURIComponent(searchTerm)}`;
    }
    if (filters) {
        URL += filters;
    }
    if (orderBy) {
        URL = `${URL}&order_by=${orderBy}`;
    }
    if (accountForReceived) {
        URL = `${URL}&account_for_received=true`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getInventoryReportSnapshots = (
    business_id: number | string,
    location_id?: number | string | null
) => {
    let URL = `${API_URLS.inventoryReportSnapshotsUrl}?business_id=${business_id}`;
    if (location_id) {
        URL += `&location_id=${location_id}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getInventoryReportSnapshot = (snapshot_id: number | string) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/`;
    return composeRequest(URL, 'GET', null);
};

export const createInventoryReportSnapshot = (data: any) => {
    const URL = API_URLS.inventoryReportSnapshotsUrl;
    return composeRequest(URL, 'POST', JSON.stringify(data));
};

export const updateInventoryReportSnapshot = (snapshot_id: number | string, data: any) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/`;
    return composeRequest(URL, 'PATCH', JSON.stringify(data));
};

export const finalizeInventoryReportSnapshot = (snapshot_id: number | string, data?: any) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/finalize/`;
    return composeRequest(URL, 'POST', data ? JSON.stringify(data) : null);
};

export const createStockOrderFromSnapshot = (snapshot_id: number | string) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/create-stock-order/`;
    return composeRequest(URL, 'POST', null);
};

export const validateInventoryReportSnapshot = (
    snapshot_id: number | string,
    page: number = 1,
    page_size: number = 20
) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/validate/`;
    return composeRequest(URL, 'POST', JSON.stringify({ page, page_size }));
};

export const getInventoryReportSnapshotItems = (
    snapshot_id: number | string,
    page: number | null = 1,
    page_size: number | null = 50,
    location_id?: number | string | null,
    supplier?: string | null,
    supplier_icontains?: string | null,
    supplier_exclude?: string | null,
    location_id_exclude?: number | string | null,
    any_short?: boolean | string | null,
    search?: string | null,
    item_ids?: number[] | null,
    orderBy?: string | null,
    no_supplier?: boolean | null,
    exclude_no_supplier?: boolean | null,
    accountForReceived?: boolean
) => {
    let URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/items/`;
    const params: string[] = [];
    if (page !== null) {
        params.push(`page=${page}`);
    }
    if (page_size !== null) {
        params.push(`page_size=${page_size}`);
    }
    if (location_id) {
        params.push(`location_id=${location_id}`);
    }
    if (supplier) {
        params.push(`supplier=${encodeURIComponent(supplier)}`);
    }
    if (supplier_icontains) {
        params.push(`supplier__icontains=${encodeURIComponent(supplier_icontains)}`);
    }
    if (supplier_exclude) {
        params.push(`supplier__exclude=${encodeURIComponent(supplier_exclude)}`);
    }
    if (location_id_exclude) {
        params.push(`location_id__exclude=${location_id_exclude}`);
    }
    if (any_short !== null && any_short !== undefined && any_short !== '') {
        params.push(`any_short=${any_short}`);
    }
    if (search) {
        params.push(`search=${encodeURIComponent(search)}`);
    }
    if (item_ids && item_ids.length > 0) {
        params.push(`item_ids=${item_ids.join(',')}`);
    }
    if (orderBy) {
        params.push(`ordering=${orderBy}`);
    }
    if (no_supplier === true) {
        params.push('no_supplier=true');
    }
    if (exclude_no_supplier === true) {
        params.push('exclude_no_supplier=true');
    }
    if (accountForReceived) {
        params.push('account_for_received=true');
    }
    if (params.length > 0) {
        URL += `?${params.join('&')}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const updateInventoryReportSnapshotItem = (
    snapshot_id: number | string,
    item_id: number | string,
    data: any
) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/items/${item_id}/`;
    return composeRequest(URL, 'PATCH', JSON.stringify(data));
};

export const bulkUpdateInventoryReportSnapshotItems = (
    snapshot_id: number | string,
    updates: Array<{ item_id: number | string; order_qty_to_place?: number; quantity_to_order?: number }>
) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/items/bulk-update/`;
    return composeRequest(URL, 'PATCH', JSON.stringify({ updates }));
};

export const prefillFromOtherSnapshot = (
    snapshot_id: number | string,
    source_snapshot_id: number | string
) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/prefill-from/${source_snapshot_id}/`;
    return composeRequest(URL, 'POST', null);
};
export const getInventoryReportSnapshotTaskStatus = (snapshotId: number) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshotId}/task-status/`;
    return composeRequest(URL, 'GET', null);
};

export const bulkResetInventoryReportSnapshotOrderQty = (
    snapshot_id: number | string,
    mode: 'ALL' | 'FILTERED' | 'VISIBLE' | 'RECALCULATE',
    order_qty: number,
    options?: {
        item_ids?: number[];
        filters?: {
            location_id?: number | string | null;
            location_id__exclude?: number | string | null;
            supplier?: string | null;
            supplier__exclude?: string | null;
            supplier__icontains?: string | null;
            any_short?: string | null;
            search?: string | null;
        };
    }
) => {
    const URL = `${API_URLS.inventoryReportSnapshotsUrl}${snapshot_id}/items/bulk-reset-order-qty/`;
    const payload: any = { mode };
    if (mode !== 'RECALCULATE') {
        payload.order_qty = order_qty;
    }
    if (mode === 'VISIBLE' && options?.item_ids) {
        payload.item_ids = options.item_ids;
    }
    if (mode === 'FILTERED' && options?.filters) {
        payload.filters = options.filters;
    }
    return composeRequest(URL, 'POST', JSON.stringify(payload));
};

export const getInventorySnapshotStockOrderTasks = (
    page?: number,
    pageSize?: number,
    orderBy?: string,
    status?: string,
    snapshotNumber?: string,
    search?: string
) => {
    let URL = API_URLS.inventorySnapshotTasksUrl + '?';
    if (page !== undefined) URL += `page=${page}&`;
    if (pageSize !== undefined) URL += `page_size=${pageSize}&`;
    if (orderBy) URL += `ordering=${encodeURIComponent(orderBy)}&`;
    if (status) URL += `status=${encodeURIComponent(status)}&`;
    if (snapshotNumber) URL += `snapshot_number=${encodeURIComponent(snapshotNumber)}&`;
    if (search) URL += `search=${encodeURIComponent(search)}&`;
    return composeRequest(URL, 'GET', null);
};

export const getInventorySnapshotStockOrderTaskItems = (
    taskId: number | string,
    page?: number,
    pageSize?: number,
    orderBy?: string,
    status?: string,
    stockOrderUuid?: string,
    stockOrderNumber?: string
) => {
    let URL = `${API_URLS.inventorySnapshotTasksUrl}${taskId}/items/?`;
    if (page !== undefined) URL += `page=${page}&`;
    if (pageSize !== undefined) URL += `page_size=${pageSize}&`;
    if (orderBy) URL += `ordering=${encodeURIComponent(orderBy)}&`;
    if (status) URL += `status=${encodeURIComponent(status)}&`;
    if (stockOrderUuid) URL += `stock_order_uuid=${encodeURIComponent(stockOrderUuid)}&`;
    if (stockOrderNumber) URL += `stock_order_number=${encodeURIComponent(stockOrderNumber)}&`;
    return composeRequest(URL, 'GET', null);
};
